import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';

import { User } from '~/types/user';

export const useAuth = () => {
  const [user, setUser] = useState<User | undefined>();

  const { user: auth0User, ...auth0 } = useAuth0<User>();
  const { getIdTokenClaims } = auth0;

  useEffect(() => {
    getIdTokenClaims().then((claims) => {
      if (claims && auth0User) {
        setUser({
          ...auth0User,
          role: claims['role'],
          roles: claims['https://brighte.com.au/roles'],
          enterprisePartnerId: claims['https://brighte.com.au/enterprisePartnerId'],
          allowExport: claims['https://brighte.com.au/allowExport'] ?? false,
        });
      } else {
        setUser(undefined);
      }
    });
  }, [auth0User, getIdTokenClaims]);

  return {
    ...auth0,
    user,
  };
};
